import { Box, Checkbox, Skeleton, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useCallback, useEffect, useState } from "react";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "auto",
      height: "auto",
      background: theme.palette.background.default,
      padding: theme.spacing(2),
      borderRadius: theme.spacing(1),
    },
    isMobilePortraitView: {
      padding: theme.spacing(1.5)
    },
    table: {
      tableLayout: "fixed",
      "& th": {
        border: "none"
      },
      "& td": {
        border: "none",
        padding: theme.spacing(1),
        paddingLeft: 0,
        paddingBottom: theme.spacing(0.5),
        paddingTop: theme.spacing(0.25),
        verticalAlign: "top",
        "&:nth-of-type(1)": {
          width: "40px",
        },
        "&:nth-of-type(2)": {
          width: "128px",
        },
        "&:nth-of-type(3)": {
          paddingRight: 0
        }
      },
      "& tr": {
        border: "none"
      },
    },
    title: {
      paddingBottom: theme.spacing(1)
    },
    checkbox: {
      marginTop: theme.spacing(-1.5),
      marginLeft: theme.spacing(-1)
    },
  })
);

export default function FieldPickerTable(props) {
  const { title, fields, data, onChange, working } = props;
  const { classes } = useStyles();
  const { isMobilePortraitView } = useDevice();

  const [values, setValues] = useState(fields.map(t => ({ name: t.name, value: !t.header && !t.renderRow })));

  useEffect(() => {
    if (typeof onChange === "function") {
      onChange(values);
    }
  }, [values, onChange]);

  const _onChange = useCallback((name, value) => {
    setValues((list) => {
      const idx = list.findIndex(t => t.name === name);

      if (idx !== -1) {
        list[idx].value = value;
      }

      return [...list];
    });
  }, []);

  return (
    <Box className={`${classes.root} ${isMobilePortraitView ? classes.isMobilePortraitView : ""}`}>
      <Table className={classes.table}>

        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant="subtitle2" className={classes.title}>{title}</Typography>
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
          {fields.map((field, key) => <FieldPickerRow field={field} key={key} value={values[key]?.value} onChange={_onChange} data={data} disabled={working} working={working} />)}
        </TableBody>
      </Table>
    </Box>
  );
}

function FieldPickerRow(props) {
  const { classes } = useStyles();
  const { onChange, value, field, disabled, data, working } = props;

  const handleChange = useCallback((ev) => {
    onChange(field.name, ev.target.checked);
  }, [field.name, onChange]);

  if (typeof field.hidden === "function") {
    const hidden = field.hidden(data || {});
    if (hidden) {
      return null;
    }
  }

  if (!!field.renderRow) {
    return (
      <TableRow>
        <TableCell colSpan={3}>{field.renderRow(data)}</TableCell>
      </TableRow>
    );
  }

  if (!!field.header) {
    return (
      <TableRow>
        <TableCell>
          <Typography variant="subtitle2" className={classes.title}>{field.header}</Typography>
        </TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow>
      <TableCell padding="checkbox">
        <Checkbox
          className={classes.checkbox}
          disabled={disabled}
          checked={value}
          onChange={handleChange}
        />
      </TableCell>
      <TableCell padding="normal">
        <Typography variant="body2" color="textSecondary" textAlign="left">{field.title}</Typography>
      </TableCell>
      <TableCell>
        {
          !!field.render ? (
            working ? <Skeleton variant="rounded" width="120px" /> : field.render(data)
          ) : (
            <Typography variant="body2" >{working ? <Skeleton variant="text" width="120px" /> : field.display(data)}</Typography>
          )
        }
      </TableCell>
    </TableRow>
  );
}